"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileCompoudEvalCondition = exports.createMultiLineFilter = exports.getFilterValueExpression = void 0;
const dbgate_tools_1 = require("dbgate-tools");
const date_fns_1 = require("date-fns");
const isString_1 = __importDefault(require("lodash/isString"));
const cloneDeepWith_1 = __importDefault(require("lodash/cloneDeepWith"));
const parseFilter_1 = require("./parseFilter");
function getDateStringWithoutTimeZone(dateString) {
    if ((0, isString_1.default)(dateString)) {
        return dateString.replace(/Z|([+-]\d{2}:\d{2})$/, '');
    }
    return dateString;
}
function getFilterValueExpression(value, dataType) {
    if (value == null)
        return 'NULL';
    if ((0, dbgate_tools_1.isTypeDateTime)(dataType))
        return (0, date_fns_1.format)((0, date_fns_1.toDate)(getDateStringWithoutTimeZone(value)), 'yyyy-MM-dd HH:mm:ss');
    if (value === true)
        return 'TRUE';
    if (value === false)
        return 'FALSE';
    if (value.$oid)
        return `ObjectId("${value.$oid}")`;
    if (value.$bigint)
        return value.$bigint;
    if (value.type == 'Buffer' && Array.isArray(value.data)) {
        return '0x' + (0, dbgate_tools_1.arrayToHexString)(value.data);
    }
    return `="${value}"`;
}
exports.getFilterValueExpression = getFilterValueExpression;
function createMultiLineFilter(mode, text) {
    let res = '';
    for (let line of text.split('\n')) {
        line = line.trim();
        if (line.length == 0)
            continue;
        if (res.length > 0) {
            switch (mode) {
                case 'is_not':
                    res += ' ';
                    break;
                default:
                    res += ',';
                    break;
            }
        }
        switch (mode) {
            case 'is':
                res += "='" + line + "'";
                break;
            case 'is_not':
                res += "<>'" + line + "'";
                break;
            case 'contains':
                res += "'" + line + "'";
                break;
            case 'begins':
                res += "^'" + line + "'";
                break;
            case 'ends':
                res += "$'" + line + "'";
                break;
        }
    }
    return res;
}
exports.createMultiLineFilter = createMultiLineFilter;
function compileCompoudEvalCondition(filters) {
    if (!filters)
        return null;
    const conditions = [];
    for (const name in filters) {
        try {
            const condition = (0, parseFilter_1.parseFilter)(filters[name], dbgate_tools_1.evalFilterBehaviour);
            const replaced = (0, cloneDeepWith_1.default)(condition, (expr) => {
                if (expr.exprType == 'placeholder')
                    return {
                        exprType: 'column',
                        columnName: name,
                    };
            });
            conditions.push(replaced);
        }
        catch (err) {
            // filter parse error - ignore filter
        }
    }
    if (conditions.length == 0)
        return null;
    return {
        conditionType: 'and',
        conditions,
    };
}
exports.compileCompoudEvalCondition = compileCompoudEvalCondition;
